import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { isNumber } from 'lodash';
import { currencySignsObj } from '@skygroup/shared/utils/constants';
import { ratesInterface } from '../interfaces';

export const convertEurToUsd = ({
  amount,
  rates,
}: {
  amount: number;
  rates: ratesInterface;
  //   fromCurrencySign: string;
  //   fromCurrencySign: '\u0024' | '\u20AC';
}) => {
  // const rates: Rates = {
  //   $: 3.8, // this amount of Shekel === 1 usd
  //   '€': 4.2, // this amount of Shekel === 1 eur
  // };
  //  thus amount of eur in shekel === amount * rates['€'] shekels
  //  and amount of eur in shekel/rates['$'] === that amount of eur in usd
  if (!rates) {
    return amount;
  }
  if (isNumber(Number(rates['$'])) && isNumber(Number(rates['€']))) {
    // through the shekels rates we convert from eur to usd
    return (amount * rates['€']) / rates['$']; // !!!!! latest fix !!!!!!
  }

  return NaN;
};

export const convertUsdToEur = ({
  amount,
  rates,
}: {
  amount: number;
  rates: ratesInterface;
}) => {
  if (!rates) {
    return amount;
  }
  if (isNumber(Number(rates['$'])) && isNumber(Number(rates['€']))) {
    // through the shekels rates we convert from eur to usd
    return (amount * rates['$']) / rates['€']; // !!!!! latest fix !!!!!!
  }

  // return NaN;
  return amount;
};

export const hasSameCurrency = (curr1: string, curr2: string) => {
  return curr1 === curr2;
};

export const useCalcTwoPrices = () => {
  const { rates } = useSelector(
    (state: RootState) => state.config.config.siteConfig
  );
  const calcTwoPrices = ({
    price1,
    curr1,
    price2,
    curr2,
  }: {
    price1: number;
    curr1: string;
    price2: number;
    curr2: string;
  }) => {
    let returnVal = price1 + price2;
    const isSameCurrency = hasSameCurrency(curr1, curr2);
    if (!isSameCurrency && curr1 === currencySignsObj.eur) {
      returnVal = convertEurToUsd({ amount: price1, rates }) + price2;
    } else if (!isSameCurrency && curr2 === currencySignsObj.eur) {
      returnVal = price1 + convertEurToUsd({ amount: price2, rates });
    }

    // return returnVal?.toFixed(2);
    return Math.ceil(returnVal);
  };

  const convertToTargetCurrency = ({
    price,
    curr,
    targetCurrency,
  }: {
    price: number;
    curr: string;
    targetCurrency: string;
  }) => {
    let returnVal = price;
    if (hasSameCurrency(curr, targetCurrency)) {
      return Math.ceil(returnVal);
    }
    if (
      curr === currencySignsObj.eur &&
      targetCurrency === currencySignsObj.usd
    ) {
      returnVal = convertEurToUsd({ amount: price, rates });
    } else if (
      curr === currencySignsObj.usd &&
      targetCurrency === currencySignsObj.eur
    ) {
      returnVal = convertUsdToEur({ amount: price, rates });
    }

    // return returnVal?.toFixed(2);
    return Math.ceil(returnVal);
  };

  const adjustFiltersPriceRangeLabels = ({
    opt_filters,
    flight_price,
    flight_currency,
  }: {
    opt_filters: any;
    flight_price?: number;
    flight_currency?: string;
  }) => {
    if (!flight_price || !flight_currency) {
      return opt_filters;
    }

    return opt_filters.map((filter: any) => {
      if (filter.attr !== 'price') {
        return filter;
      }
      return {
        ...filter,
        adjusted_min_label: calcTwoPrices({
          price1: filter?.min,
          curr1: filter?.unit,
          price2: flight_price,
          curr2: flight_currency,
        }),
        adjusted_max_label: calcTwoPrices({
          price1: filter?.max,
          curr1: filter?.unit,
          price2: flight_price,
          curr2: flight_currency,
        }),
      };
    });
  };

  return {
    adjustFiltersPriceRangeLabels,
    convertToTargetCurrency,
    calcTwoPrices,
  };
};

export const getTotalPaxFromMultiRoom = ({
  multi_room_guests,
  adult,
  child,
}: {
  multi_room_guests: {
    adult: number | string;
    child: number | string;
    infant: number | string;
  }[];
  adult: number;
  child: number;
}) => {
  if (Array.isArray(multi_room_guests) && multi_room_guests?.length > 0) {
    let totalCount = 0;
    multi_room_guests.forEach(
      (pax: {
        adult: number | string;
        child: number | string;
        infant: number | string;
      }) => {
        totalCount += +pax.adult;
        totalCount += +pax.child;
      }
    );

    return totalCount;
  }

  return adult + child;
};
